import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, } from 'react-bootstrap';
import Select from 'react-select';
import { ChooseComponent, useFetch, useTranslation, usePermission } from '@np/np_webcomponentlib'

import { API_BUSINESS, API_RATEDATA } from '../../shared/consts/api'

import { EntityType, DataEntityType, EntityFormPropsWithType, initEntity, columnsForChoose } from './BusinessTypes'

import {  optionsEnumTypePaymentMethodEnum } from '../DRRateComission/DRRateComissionTypes'

import { optionsEnumTypeBusiness, optionsTypeCurrencyEnum, TypeBusinessEnum } from '../../shared/MasterData/MasterDataTypes';





// import { ColumnWithCopyToClipboard, ColumnData } from '../../shared/entityOperations/EntityOperationsCustomFC'






// Тип для RateSource
interface RateSourceItem {
    idUnique: string;
    name: string;
}

export const BusinessForm = ({ title, idInit, handleClose, initEntityProps }: EntityFormPropsWithType) => {

    const { canView, canCreate, canUpdate, canRemove, debugMode } = usePermission('$component_name');

    const [currentID, setCurrentID] = useState<string | null>(idInit)
    const [entity, setEntity] = useState<EntityType | DataEntityType>(initEntityProps !== undefined ? initEntityProps : initEntity)
    const [rateSources, setRateSources] = useState<RateSourceItem[]>([])





    useEffect(() => {
        setCurrentID(idInit)
    }, [idInit])

    const [, doFetchLoad] = useFetch(
        `${API_BUSINESS}business/${currentID}`)//{ error: errLoad, isLoading: isLoadLoad, response: respLoad }


    
        const [, doFetchCreateUpdate] = useFetch(
            `${API_BUSINESS}business`)//{ error: errCU, isLoading: isLoadCU, response: respCU }

    // Загрузка списка источников курса
    const [, doFetchRateSources] = useFetch(`${API_RATEDATA}ratesource/list`)



    useEffect(() => {
        if (currentID === "") {
            return
        }
        doFetchLoad({
            method: 'GET',
            "Content-Type": "application/json"
        }).then(responce => {
            setEntity(responce.data)
            console.log(responce.data)
        })
    }, [currentID])

    // Загрузка списка источников курса при монтировании
    useEffect(() => {
        doFetchRateSources({
            method: 'POST',
            "Content-Type": "application/json",
            data: { listFields: [], sort: null, searchData: '', skip: 0, take: 100 }
        }).then(response => {
            if (response.dataList) {
                setRateSources(response.dataList.map((rs: any) => ({
                    idUnique: rs.idUnique,
                    name: rs.name
                })))
            }
        }).catch(err => console.error('Failed to load rate sources:', err))
    }, [])


    const handleSave = () => {
        //сначала проверим заполненность

        var method = "POST"
        if (currentID !== "") {
            method = "PATCH"
        }

        doFetchCreateUpdate({
            method: method,
            "Content-Type": "application/json",
            data: entity
        }).then(responce => {
            console.log(responce)
            setEntity(responce.data)
            console.log("responce.result.status", responce.result.status)
            if (responce.result.status === "success") {
                handleClose();
            }
            console.log(responce.data)
        })


    }




    const confirmButtonTitle = "Загрузить";//useTranslation('confirmButtonTitle')
    const rejectButtonTitle = useTranslation('rejectButtonTitle')

    const createButtonTitle = useTranslation('createButton')
    const updateButtonTitle = useTranslation('updateButton')


    return (<Card>
        <Card.Header>
            <Card.Title as='h4'>{title}</Card.Title>
        </Card.Header>
        <Card.Body className="">
            {/* <Form className="form-horizontal"> */}

            

            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('typeBusiness')}</Form.Label>
                <Col md={9}>
                    <Select options={optionsEnumTypeBusiness} placeholder='choose one' classNamePrefix='Select' value={optionsEnumTypeBusiness.find(option => option.value === entity.typeBusiness) ?? optionsEnumTypeBusiness[0]}
                        onChange={e => setEntity((prev) => { return { ...prev, typeBusiness: e!.value } })} />
                </Col>
            </Row>

            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('name')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('name')} value={entity.name} onChange={e => setEntity((prev) => { return { ...prev, name: e.target.value } })} />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('fullName')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('fullName')} value={entity.fullName} onChange={e => setEntity((prev) => { return { ...prev, fullName: e.target.value } })} />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('currencyPayment')}</Form.Label>
                <Col md={9}>
                <Select options={optionsTypeCurrencyEnum} placeholder='choose one' classNamePrefix='Select' value={optionsTypeCurrencyEnum.find(option => option.value === entity.currencyPayment) ?? optionsTypeCurrencyEnum[0]}
                        onChange={e => setEntity((prev) => { 
                            if (e && e.value) {  // проверка на наличие значения
                              return { 
                                ...prev, 
                                currencyPayment: e.value 
                              }; 
                            }
                            return prev;  // если нет значения, не изменяем состояние
                          })}  />
                </Col>
            </Row>



            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('currencyBalance')}</Form.Label>
                <Col md={9}>
                <Select options={optionsTypeCurrencyEnum} placeholder='choose one' classNamePrefix='Select' value={optionsTypeCurrencyEnum.find(option => option.value === entity.currencyBalance) ?? optionsTypeCurrencyEnum[0]}
                        onChange={e => setEntity((prev) => { 
                            if (e && e.value) {  // проверка на наличие значения
                              return { 
                                ...prev, 
                                currencyBalance: e.value 
                              }; 
                            }
                            return prev;  // если нет значения, не изменяем состояние
                          })}  />
                </Col>
            </Row>


           

            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('contractText')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('contractText')} value={entity.contractText} onChange={e => setEntity((prev) => { return { ...prev, contractText: e.target.value } })} />
                </Col>
            </Row>

            


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('techChat')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('techChat')} value={entity.techChat} onChange={e => setEntity((prev) => { return { ...prev, techChat: e.target.value } })} />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('receiptChatId')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('receiptChatId')} value={entity.receiptChatId ?? ''} onChange={e => setEntity((prev) => { return { ...prev, receiptChatId: e.target.value } })} />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('receiptForwardEnabled')}</Form.Label>
                <Col md={9}>
                    <Form.Check type="switch" checked={entity.receiptForwardEnabled ?? false} onChange={e => setEntity((prev) => { return { ...prev, receiptForwardEnabled: e.target.checked } })} />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('contactEmail')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('contactEmail')} value={entity.contactEmail} onChange={e => setEntity((prev) => { return { ...prev, contactEmail: e.target.value } })} />
                </Col>
            </Row>




            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('noteText')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('noteText')} value={entity.noteText} onChange={e => setEntity((prev) => { return { ...prev, noteText: e.target.value } })} />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('providerURLHost')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('providerURLHost')} value={entity.providerURLHost} onChange={e => setEntity((prev) => { return { ...prev, providerURLHost: e.target.value } })} />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('webHook')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('webHook')} value={entity.webHook} onChange={e => setEntity((prev) => { return { ...prev, webHook: e.target.value } })} />
                </Col>
            </Row>

            
            


            
            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('redirectGeneralURL')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('redirectGeneralURL')} value={entity.redirectGeneralURL} onChange={e => setEntity((prev) => { return { ...prev, redirectGeneralURL: e.target.value } })} />
                </Col>
            </Row>



            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('redirectSuccessURL')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('redirectSuccessURL')} value={entity.redirectSuccessURL} onChange={e => setEntity((prev) => { return { ...prev, redirectSuccessURL: e.target.value } })} />
                </Col>
            </Row>



            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('redirectFailURL')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('redirectFailURL')} value={entity.redirectFailURL} onChange={e => setEntity((prev) => { return { ...prev, redirectFailURL: e.target.value } })} />
                </Col>
            </Row>

            {/* Разделительная линия */}
            <hr className="my-4" style={{ borderColor: 'var(--trt-border)', borderWidth: '1px' }} />

            <h2>Рандомизация</h2>
<Row className="mb-4">
    <Form.Label className="col-md-3">Рандомизация</Form.Label>
    <Col md={9}>
        {entity.maxForwardRandomization > 0 ? (
            <div style={{ color: 'var(--trt-success)', fontWeight: 'bold' }}>
                Рандомизация включена
            </div>
        ) : (
            <div style={{ color: 'var(--trt-warning)', fontWeight: 'bold' }}>
                Рандомизация отключена
            </div>
        )}
        <Form.Group className="mt-2" controlId="maxForwardRandomization">
            <Form.Label>Максимум forward рандомизации</Form.Label>
            <Form.Control
                type="number"
                value={entity.maxForwardRandomization ?? ''}
                onChange={e =>
                    setEntity(prev => ({
                        ...prev,
                        maxForwardRandomization: Number(e.target.value)
                    }))
                }
                placeholder="Введите число"
                min={0}
            />
        </Form.Group>
    </Col>
</Row>

{/* Разделительная линия */}
<hr className="my-4" style={{ borderColor: 'var(--trt-border)', borderWidth: '1px' }} />

<h2>Курс</h2>
<Row className="mb-4">
    <Col md={6}>
        <Form.Group controlId="idSourceRate">
            <Form.Label>Источник курса</Form.Label>
            <Form.Select
                value={entity.idSourceRate ?? ''}
                onChange={e => setEntity(prev => ({
                    ...prev,
                    idSourceRate: e.target.value || null
                }))}
            >
                <option value="">По умолчанию</option>
                {rateSources.map(rs => (
                    <option key={rs.idUnique} value={rs.idUnique}>
                        {rs.name}
                    </option>
                ))}
            </Form.Select>
        </Form.Group>
    </Col>
    <Col md={6}>
        <Form.Group controlId="percentageOfExchangeRateSource">
            <Form.Label>Надбавка к курсу (%)</Form.Label>
            <Form.Control
                type="number"
                step="0.1"
                value={entity.percentageOfExchangeRateSource ?? 0}
                onChange={e => setEntity(prev => ({
                    ...prev,
                    percentageOfExchangeRateSource: Number(e.target.value)
                }))}
                placeholder="0.0"
            />
        </Form.Group>
    </Col>
</Row>

{/* Разделительная линия */}
<hr className="my-4" style={{ borderColor: 'var(--trt-border)', borderWidth: '1px' }} />

<h2>Монобанк</h2>



            

            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('paymentMethodMonoBank')}</Form.Label>
                <Col md={9}>
                    <Select options={optionsEnumTypePaymentMethodEnum} placeholder='choose one' classNamePrefix='Select' value={optionsEnumTypePaymentMethodEnum.find(option => option.value === entity.monoBankPaymentMethod) ?? optionsEnumTypePaymentMethodEnum[0]}
                        onChange={e => setEntity((prev) => { return { ...prev, monoBankPaymentMethod: e!.value } })} />
                </Col>
            </Row>



            <Row className="mb-0">
                {canCreate && currentID === "" &&
                    <Button onClick={() => { handleSave(); console.log(entity) }}> {createButtonTitle} </Button>
                }

                {canUpdate && currentID !== "" &&
                    <Button onClick={() => { handleSave(); console.log(entity) }}> {updateButtonTitle} </Button>
                }


            </Row>





        </Card.Body>
    </Card>)
}
